module.exports = __webpack_public_path__ + "static/media/Group_Logo.64f847fc.png";